import { SHOP_URL } from "./shopUrl";

export default function ShopDescription() {
    return (
        <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                backgroundColor: "white",
                padding: "16px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                fontSize: "14px",
                lineHeight: "1.5",
                textAlign: "center",
                display: "block",
                color: "inherit",
            }}
        >
            <h4
                style={{
                    margin: "0 0 12px 0",
                    color: "#1890ff",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                }}
            >
                <img
                    src="/edu-robot-shop.png"
                    alt="Edu Robo Shop"
                    style={{
                        width: "100px",
                        height: "100px",
                    }}
                />
            </h4>
            <p style={{ margin: "0" }}>
                Posjetite našu novu internet trgovinu s edukacijskom robotičkom
                opremom.
            </p>
        </a>
    );
}
